interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
}

export default function SectionHeader({ eyebrow, title, subtitle, align = "left" }: SectionHeaderProps) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignCls} gap-3`}>
      <span className="flex items-center gap-2 text-sm font-bold tracking-wide text-primary-500">
        <i className="ri-fire-line text-base" />
        {eyebrow}
        <span className="h-px w-8 bg-primary-300" />
      </span>
      <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {subtitle && <p className="max-w-2xl text-sm leading-relaxed text-foreground-600">{subtitle}</p>}
    </div>
  );
}